import { color, Text } from '@morressier/ts';

import styled from 'styled-components';

import NextImage from 'components/NextImage';
import { FeatureFlags } from 'config/featureFlags';

import * as Styles from './styles';

const LinkWrapper = styled.div`
  display: flex;
  border: 1px solid ${color('lightGrey')};
  padding: 8px;
  align-items: end;
  width: fit-content;
`;

const LogoImageWrapper = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  object-fit: cover;
  align-self: center;
  border-radius: 50%;
  border: none;
  z-index: 1;
  position: relative;
  border: 4px solid ${color('white')};
  overflow: hidden;
`;

const OrganizationLinkWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
`;

type OrganizationLinkProps = {
  organizationData: MorressierOrganization;
  contentLibrary?: string;
};

const OrganizationLink: React.FC<OrganizationLinkProps> = props => {
  const { organizationData, contentLibrary } = props;
  return (
    <OrganizationLinkWrapper>
      <Styles.ProductLabel className="mb1">Explore more content from</Styles.ProductLabel>
      <LinkWrapper>
        {organizationData?.brand_theme?.logo_url && (
          <LogoImageWrapper>
            <NextImage
              src={organizationData.brand_theme.logo_url || ''}
              width={50}
              height={50}
              objectFit="cover"
              alt={`${contentLibrary || organizationData.name} logo`}
            />
          </LogoImageWrapper>
        )}
        <a
          target="_blank"
          rel="noreferrer"
          href={`/${
            FeatureFlags.Content_Library_Repository.isEnabled() ? 'cl' : 'o'
          }/organizations/${organizationData?.id}`}
        >
          <Text
            as="a"
            style={{
              fontSize: '1rem',
              lineHeight: '2rem',
              cursor: 'pointer',
              textDecoration: 'underline',
              marginBottom: '0.5rem',
            }}
          >
            {organizationData?.name}
          </Text>
        </a>
      </LinkWrapper>
    </OrganizationLinkWrapper>
  );
};

export default OrganizationLink;
